import React, {ReactNode} from 'react';

import {faImage} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Avatar from 'components/Avatar/Avatar';
import ContactDetails from 'components/ContactDetails/ContactDetails';
import Description from 'components/Description/Description';
import EditToggler from 'components/EditToggler/EditToggler';
import Text from 'components/Text/Text';
import './OverviewHeaderMobile.scss';

interface IProps {
  name: string;
  description: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  facebook: string;
  instagram: string;
  logo?: string | null;
  handleEdit: () => void;
  IconElement?: ReactNode;
  isDropdownOpen: boolean;
  setIsDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const OverviewHeaderMobileTablet = (props: IProps) => {
  const {
    name,
    description,
    logo,
    email,
    address,
    website,
    facebook,
    instagram,
    phone,
    handleEdit,
    IconElement,
    isDropdownOpen,
    setIsDropdownOpen,
  } = props;

  return (
    <div className="overview-header">
      {isDropdownOpen && <div className="overview-header--wrap" />}

      <div className="overview-header__wrap">
        <div className="overview-header__general">
          <div className="overview-header__avatar">
            <Avatar imageSource={logo || ''} Icon={IconElement || <FontAwesomeIcon icon={faImage} />} />
          </div>
          <div className="overview-header__info">
            <div className="overview-header__info-wrapper">
              <Text tag="h1">{name}</Text>
              <EditToggler handleClick={handleEdit} />
            </div>
            <Description text={description || ''} cutLength={195} />
          </div>
        </div>
        <div className="overview-header__social">
          <ContactDetails
            setIsDropdownOpen={setIsDropdownOpen}
            address={address}
            phone={phone}
            email={email}
            website={website}
            facebook={facebook}
            instagram={instagram}
          />
        </div>
      </div>
    </div>
  );
};
